/* unplugin-vue-components disabled */import { render } from "./BaseSpacer.vue?vue&type=template&id=740bcd28"
import script from "./BaseSpacer.vue?vue&type=script&lang=js"
export * from "./BaseSpacer.vue?vue&type=script&lang=js"

import "./BaseSpacer.vue?vue&type=style&index=0&id=740bcd28&lang=scss"
script.render = render

export default script